var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.isEdit ? _vm.$t("SeaExport.Edit") : _vm.$t("SeaExport.Add"),
        "close-on-click-modal": false,
        width: "768px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          attrs: {
            "label-width": "165px",
            inline: "",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            { staticClass: "marginLeft", attrs: { label: "UN No" } },
            [
              _c("el-input", {
                ref: "txtUnNo",
                attrs: { disabled: _vm.isEdit },
                model: {
                  value: _vm.imdgCode.unNo,
                  callback: function($$v) {
                    _vm.$set(_vm.imdgCode, "unNo", $$v)
                  },
                  expression: "imdgCode.unNo"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: "Special Provisions" }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.imdgCode.specialProvisions,
                  callback: function($$v) {
                    _vm.$set(_vm.imdgCode, "specialProvisions", $$v)
                  },
                  expression: "imdgCode.specialProvisions"
                }
              })
            ],
            1
          ),
          _c("br"),
          _c(
            "el-form-item",
            { staticClass: "marginLeft", attrs: { label: "PSN" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.imdgCode.psn,
                  callback: function($$v) {
                    _vm.$set(_vm.imdgCode, "psn", $$v)
                  },
                  expression: "imdgCode.psn"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: "Limited Quantities" }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.imdgCode.limitedQuantities,
                  callback: function($$v) {
                    _vm.$set(_vm.imdgCode, "limitedQuantities", $$v)
                  },
                  expression: "imdgCode.limitedQuantities"
                }
              })
            ],
            1
          ),
          _c("br"),
          _c(
            "el-form-item",
            { staticClass: "marginLeft", attrs: { label: "Class" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.imdgCode.classification,
                  callback: function($$v) {
                    _vm.$set(_vm.imdgCode, "classification", $$v)
                  },
                  expression: "imdgCode.classification"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: "Excepted Quantitiess" }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.imdgCode.exceptedQuantities,
                  callback: function($$v) {
                    _vm.$set(_vm.imdgCode, "exceptedQuantities", $$v)
                  },
                  expression: "imdgCode.exceptedQuantities"
                }
              })
            ],
            1
          ),
          _c("br"),
          _c(
            "el-form-item",
            { staticClass: "marginLeft", attrs: { label: "Subsidiary Risks" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.imdgCode.subsidiaryRisks,
                  callback: function($$v) {
                    _vm.$set(_vm.imdgCode, "subsidiaryRisks", $$v)
                  },
                  expression: "imdgCode.subsidiaryRisks"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "marginLeft", attrs: { label: "Flashpoint" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.imdgCode.flashpoint,
                  callback: function($$v) {
                    _vm.$set(_vm.imdgCode, "flashpoint", $$v)
                  },
                  expression: "imdgCode.flashpoint"
                }
              })
            ],
            1
          ),
          _c("br"),
          _c(
            "el-form-item",
            { staticClass: "marginLeft", attrs: { label: "Packing Group" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.imdgCode.packingGroup,
                  callback: function($$v) {
                    _vm.$set(_vm.imdgCode, "packingGroup", $$v)
                  },
                  expression: "imdgCode.packingGroup"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: "Emergency Schedule" }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.imdgCode.emergencySchedule,
                  callback: function($$v) {
                    _vm.$set(_vm.imdgCode, "emergencySchedule", $$v)
                  },
                  expression: "imdgCode.emergencySchedule"
                }
              })
            ],
            1
          ),
          _c("br"),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: "Packing Instructions" }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.imdgCode.packingInstruction,
                  callback: function($$v) {
                    _vm.$set(_vm.imdgCode, "packingInstruction", $$v)
                  },
                  expression: "imdgCode.packingInstruction"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: "Packing Provisions" }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.imdgCode.packingProvisions,
                  callback: function($$v) {
                    _vm.$set(_vm.imdgCode, "packingProvisions", $$v)
                  },
                  expression: "imdgCode.packingProvisions"
                }
              })
            ],
            1
          ),
          _c("br"),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: "IBCs Instructions" }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.imdgCode.ibcsInstruction,
                  callback: function($$v) {
                    _vm.$set(_vm.imdgCode, "ibcsInstruction", $$v)
                  },
                  expression: "imdgCode.ibcsInstruction"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "marginLeft", attrs: { label: "IBCs Provisions" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.imdgCode.ibcsProvisions,
                  callback: function($$v) {
                    _vm.$set(_vm.imdgCode, "ibcsProvisions", $$v)
                  },
                  expression: "imdgCode.ibcsProvisions"
                }
              })
            ],
            1
          ),
          _c("br"),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: "Tanks Instructions" }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.imdgCode.tanksInstruction,
                  callback: function($$v) {
                    _vm.$set(_vm.imdgCode, "tanksInstruction", $$v)
                  },
                  expression: "imdgCode.tanksInstruction"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "marginLeft", attrs: { label: "Tanks Provisions" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.imdgCode.tanksProvisions,
                  callback: function($$v) {
                    _vm.$set(_vm.imdgCode, "tanksProvisions", $$v)
                  },
                  expression: "imdgCode.tanksProvisions"
                }
              })
            ],
            1
          ),
          _c("br"),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: "Stowage and Handling" }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.imdgCode.stowageHandling,
                  callback: function($$v) {
                    _vm.$set(_vm.imdgCode, "stowageHandling", $$v)
                  },
                  expression: "imdgCode.stowageHandling"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "marginLeft", attrs: { label: "Segregation" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.imdgCode.segregation,
                  callback: function($$v) {
                    _vm.$set(_vm.imdgCode, "segregation", $$v)
                  },
                  expression: "imdgCode.segregation"
                }
              })
            ],
            1
          ),
          _c("br"),
          _c(
            "el-form-item",
            {
              staticClass: "marginLeft",
              attrs: { label: "Properties and Observations" }
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.imdgCode.propertiesObservations,
                  callback: function($$v) {
                    _vm.$set(_vm.imdgCode, "propertiesObservations", $$v)
                  },
                  expression: "imdgCode.propertiesObservations"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { "text-align": "center" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.saveHandler } },
            [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
          ),
          _c("el-button", { on: { click: _vm.closeHandler } }, [
            _vm._v(_vm._s(_vm.$t("common.btn.close")))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }